module.exports = __webpack_public_path__ + "static/media/2019_conf_Moving_into_Management_Leadership.797b12e4.png";